import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-092ddf3c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "boxs_c"
};
import TagItem from "@/components/tag-item/index.vue";
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const tag_list = ref([{
      id: 3,
      name: "常规群聊"
    }, {
      id: 4,
      name: "已解散"
    }]);
    const cha_id = ref("");
    const item_chats = ref("");
    const set_chart2 = item => {
      types.value = 2;
      cha_id.value = item.chat_id;
      item_chats.value = item;
    };
    const types = ref(2);
    return (_ctx, _cache) => {
      const _component_chatting = _resolveComponent("chatting");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(TagItem, {
        show_chat: true,
        tag_list: tag_list.value,
        onSet_chart2: set_chart2
      }, null, 8, ["tag_list"]), _createVNode(_component_chatting, {
        class: "margin-l-20",
        item_chats: item_chats.value,
        cha_id: cha_id.value,
        types: types.value
      }, null, 8, ["item_chats", "cha_id", "types"])]);
    };
  }
});